var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaycheck = function SvgPaycheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 7.8c-.6.1-.8.3-.8.7 0 .4.2.6.8.8V7.8zM5.8 11.4c0-.4-.2-.6-.9-.8v1.6c.6-.1.9-.3.9-.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4C.7 4 0 4.7 0 5.5v9c0 .8.7 1.5 1.5 1.5h17c.8 0 1.5-.7 1.5-1.5v-9c0-.8-.7-1.5-1.5-1.5h-17zm3.6 5.5c1.3.3 1.9.8 1.9 1.8 0 1.2-.9 1.9-2.1 2v.7h-.7v-.8c-1.4-.1-2.2-.8-2.2-2.1h1.2c0 .6.3.9.9 1v-1.8H4c-1.3-.3-1.9-.8-1.9-1.8s.7-1.8 2-1.9V6h.7v.8c1.3.1 1.9.9 2 2H5.7c0-.5-.3-.8-.7-.9v1.6h.1zM10 7c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1h-7zm-1 5c0-.6.4-1 1-1h5c.6 0 1 .4 1 1s-.4 1-1 1h-5c-.6 0-1-.4-1-1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgPaycheck;